import React from 'react';
import {
  TmoH2,
  TmoDropDownSelect
} from '@tmobile/tmo-bps-syncup-web-component-lib';
import PageHeader from '../../components/uiHelpers/pageHeader/PageHeader';
import { IoIosArrowDown } from 'react-icons/all';
import { hasValue } from '../../utils/helper_functions';
import style from './Things.module.css';

const ThingHeader = ({
  things,
  activeThings,
  deletedThingsCount,
  thingTypeName,
  setCurrentThingId,
  thingActions
}) => {
  if (!things || things.length < 2) {
    return <PageHeader title={thingTypeName}>{thingActions}</PageHeader>;
  }

  return (
    <div className={style.heading}>
      <div className={style.thing_details}>
        <div className={style.thing_number}>
          <TmoH2 flush className={style.label}>
            {activeThings.length > 1 ? 'Select ' : ''}
            {thingTypeName}
          </TmoH2>

          <div className={style.subtitle}>
            {things.length} {thingTypeName.toLowerCase()} are in this list
            {deletedThingsCount > 0 && (
              <small className={style.heading_deleted_things}>
                (*Not displaying <strong>{deletedThingsCount}</strong> deleted{' '}
                {thingTypeName})
              </small>
            )}
          </div>
        </div>

        <div className={style.custom_dropdown}>
          {hasValue(activeThings) && activeThings.length > 1 && (
            <TmoDropDownSelect
              optionsList={activeThings.map(o => ({
                key: o.id,
                value: o.name
              }))}
              onChange={setCurrentThingId}
              renderIcon={<IoIosArrowDown />}
              defaultSelectedValue={{
                key: activeThings[0].id,
                value: activeThings[0].name
              }}
            />
          )}
        </div>
      </div>

      {thingActions}
    </div>
  );
};

export default ThingHeader;
